import { getDataAPI, postDataAPI, putDataAPI, deleteDataAPI } from './fetchData';

// Get Google Meet auth URL for OAuth flow
export const getMeetAuthUrl = async () => {
  const token = localStorage.getItem('dizeeToken');
  const res = await getDataAPI('user/meet/auth-url', token);
  return res.data?.data;
};

// Exchange OAuth code for tokens
export const exchangeMeetCode = async (code, state) => {
  const token = localStorage.getItem('dizeeToken');
  const res = await postDataAPI('user/meet/exchange-code', { code, state }, token);
  return res.data;
};

// Get Google Meet connection status
export const getMeetStatus = async () => {
  const token = localStorage.getItem('dizeeToken');
  const res = await getDataAPI('user/meet/status', token);
  return res.data?.data;
};

// Disconnect Google Meet
export const disconnectMeet = async () => {
  const token = localStorage.getItem('dizeeToken');
  const res = await postDataAPI('user/meet/disconnect', {}, token);
  return res.data;
};

// Get upcoming meetings from calendar
export const getUpcomingMeetings = async () => {
  const token = localStorage.getItem('dizeeToken');
  const res = await getDataAPI('user/meet/upcoming', token);
  return res.data?.data?.meetings || [];
};

// Toggle auto-join for meetings
export const toggleAutoJoin = async (enabled) => {
  const token = localStorage.getItem('dizeeToken');
  const res = await postDataAPI('user/meet/toggle-auto-join', { enabled }, token);
  return res.data;
};

// Get meeting recordings history
export const getRecordings = async (limit = 50, status = null) => {
  const token = localStorage.getItem('dizeeToken');
  const params = new URLSearchParams();
  if (limit) params.append('limit', limit.toString());
  if (status) params.append('status', status);
  const res = await getDataAPI(`user/meet/recordings?${params.toString()}`, token);
  return res.data?.data?.recordings || [];
};

// Update meeting settings
export const updateMeetSettings = async (settings) => {
  const token = localStorage.getItem('dizeeToken');
  const res = await postDataAPI('user/meet/settings', settings, token);
  return res.data;
};

// Format meeting duration
export const formatDuration = (seconds) => {
  if (!seconds) return '0 min';
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  
  if (hours > 0) {
    return `${hours}h ${minutes}m`;
  }
  return `${minutes}m`;
};

// Format meeting status with emoji
export const formatMeetingStatus = (status) => {
  const statusMap = {
    'scheduled': { label: 'Scheduled', emoji: '📅', color: '#FFA500' },
    'joining': { label: 'Joining', emoji: '🔄', color: '#17A2B8' },
    'recording': { label: 'Recording', emoji: '🎙️', color: '#28A745' },
    'processing': { label: 'Processing', emoji: '⚙️', color: '#FFC107' },
    'completed': { label: 'Completed', emoji: '✅', color: '#5856D6' },
    'failed': { label: 'Failed', emoji: '❌', color: '#DC3545' },
    'cancelled': { label: 'Cancelled', emoji: '🚫', color: '#6C757D' }
  };
  
  return statusMap[status] || { label: status, emoji: '❓', color: '#6C757D' };
};

